import TourPage from "@/components/TourPage";

export default function KidepValley5Day() {
  return (
    <TourPage
      tourId="uganda/kidepo-valley-5-day"
      title="5-Day Kidepo Valley National Park Safari"
      duration="5 Days / 4 Nights"
      price="Contact for price"
      image="/5O5A0035.png"
      description="Discover the remote wilderness of Kidepo Valley National Park, one of Africa's most spectacular parks. Experience unique wildlife viewing, stunning landscapes, and authentic cultural encounters in this pristine corner of Uganda."
      itinerary={[
        {
          day: 1,
          title: "Flight to Kidepo Valley",
          description: "Begin your journey to the remote wilderness.",
          activities: [
            "Morning flight from Entebbe to Kidepo",
            "Transfer to your lodge",
            "Afternoon game drive",
            "Evening relaxation at the lodge"
          ],
          accommodation: "Apoka Safari Lodge or similar",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Full Day Game Drives",
          description: "Explore the diverse wildlife of Kidepo Valley.",
          activities: [
            "Early morning game drive",
            "Search for lions, elephants, and buffalo",
            "Afternoon game drive in different sectors",
            "Evening sundowner"
          ],
          accommodation: "Apoka Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Wildlife and Culture",
          description: "Combine wildlife viewing with cultural experiences.",
          activities: [
            "Morning game drive",
            "Visit to Karamojong village",
            "Cultural interactions and demonstrations",
            "Evening game drive"
          ],
          accommodation: "Apoka Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Nature Walks and Game Drives",
          description: "Experience the park from different perspectives.",
          activities: [
            "Guided nature walk with armed ranger",
            "Visit to the hot springs",
            "Afternoon game drive",
            "Night game drive option"
          ],
          accommodation: "Apoka Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Return Flight to Entebbe",
          description: "Final game drive and return journey.",
          activities: [
            "Early morning game drive",
            "Breakfast at the lodge",
            "Flight back to Entebbe",
            "Transfer to your hotel or airport"
          ],
          meals: "Breakfast"
        }
      ]}
      inclusions={[
        "Return flights to Kidepo",
        "Park entrance fees",
        "Game drives",
        "English-speaking guide",
        "Accommodation as listed",
        "Meals as specified",
        "Cultural visit fees",
        "All transfers"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips and gratuities",
        "Drinks and beverages",
        "Optional activities",
        "Night game drive fees"
      ]}
    />
  );
}
